var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.params.text
    ? _c("badgeComponent", {
        staticClass: "badge-list",
        attrs: { text: _vm.text, badgeClass: _vm.badgeClass }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }